// TODO: Move walletError to types
import { WalletError } from "@b2bportal/hopper-wallet-api";
import { WalletOffer, WalletVoucherStatusEnum } from "@hopper-b2b/types";

export interface WalletContext {
  selectedOffer?: WalletOffer;
  offers?: WalletOffer[];
  visited: boolean;
  error?: WalletError;
  fetchedOffers?: boolean;
  offerApplied?: boolean;
  offerStatus?: WalletVoucherStatusEnum;
}

export const getIntialWalletContext = () => ({
  selectedOffer: undefined,
  offers: [],
  visited: false,
  error: undefined,
  fetchedOffers: false,
  offerApplied: false,
  offerStatus: WalletVoucherStatusEnum.DEFAULT_OPT_IN,
});
